import { useEffect, useState } from 'react';

import { resolveAppDensityMode, type AppDensityMode } from '@/features/shared/lib/appDensityMode';

export function useAppDensityMode(): AppDensityMode {
  const [mode, setMode] = useState<AppDensityMode>(() => resolveAppDensityMode());

  useEffect(() => {
    const compactQuery = window.matchMedia('(max-width: 767px)');
    const cozyQuery = window.matchMedia('(max-width: 1023px), (pointer: coarse)');
    const updateMode = () => setMode(resolveAppDensityMode());

    compactQuery.addEventListener('change', updateMode);
    cozyQuery.addEventListener('change', updateMode);

    return () => {
      compactQuery.removeEventListener('change', updateMode);
      cozyQuery.removeEventListener('change', updateMode);
    };
  }, []);

  return mode;
}
